<script setup lang="ts">
import StepView from '../../views/StepView/StepView.vue';
import StepTheoryView from '../../views/StepTheoryView/StepTheoryView.vue';
import StepLoadBanners from '../../components/StepLoadBanners/StepLoadBanners.vue';
import BPage from 'src/shared/components/base/BPage/BPage.vue';
import { useRoute, useRouter } from 'vue-router';
import { useStepPageView } from '../../composables/useStepPageView';

const route = useRoute();
const router = useRouter();

const { stepDocId } = route.params;
const { view, loadError, validationErrors, retry } = useStepPageView(
  stepDocId as string,
);
</script>

<template>
  <BPage>
    <div class="col fit full-width">
      <StepTheoryView v-if="view === 'theory'" />
      <StepView v-else-if="view === 'drill'" />
      <StepLoadBanners
        v-else-if="view === 'error'"
        :load-error="loadError"
        :validation-errors="validationErrors"
        is-not-found
        @retry="retry"
        @back="router.back()"
        @home="router.push({ name: 'dashboard' })"
      />
      <div
        v-else
        class="flex flex-center full-height"
      >
        <q-spinner-gears
          size="80px"
          color="primary"
        />
      </div>
    </div>
  </BPage>
</template>
